import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'cass-ad-preview',
	templateUrl: './ad-preview.component.html',
	styleUrls: ['./ad-preview.component.css']
})
export class AdPreviewComponent implements OnInit {

	@Input() previewDataURL: string | undefined = "";
	@Input() isCalculating: boolean = false;
	@Input() message?: string = "";
	@Input() isError: boolean = false;

	constructor() { }

	ngOnInit(): void {
	}

}
